import React from 'react';
import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/leaflet.js';


import { MapContainer, TileLayer, Marker,Popup } from 'react-leaflet';
import L from 'leaflet';

// Importez les images des marqueurs depuis le dossier 'images'
import markerIcon from '../../assets/images/marker-icon.png';
import markerShadow from '../../assets/images/marker-shadow.png';

function MapComponent({lattitude,longitude}) {
  const markerIconDefault = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  // [-5.847278, 13.446038]
  return (
    <MapContainer center={[lattitude, longitude]} zoom={15} style={{ height: '350px' ,width:'80%' }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={[lattitude, longitude]} icon={markerIconDefault}>
      <Popup closeButton={false} autoClose={false} closeOnClick={false}>
          <b>Notre Bureau</b><br />
          Av.Ruphin kisilu 40
        </Popup>
      </Marker>
    </MapContainer>
  );
}

export default MapComponent;
